//-- Copyright (c) 2021 TMT Insights Group, LLC
import { capitalizeNoun } from '@/_utils/utils';
import { DateTimeDisplay, EditableTextCell, UserDisplay } from '@/exports/columnCommonComponents';
import { AssemblyTemplate, AssemblyTemplateBEResponse } from '@/redux/slices/packagingSlice.types';
import AssemblyTemplatesOverflowMenu from './AssemblyTemplatesOverflowMenu';
import AssemblyTemplatesRowExpand from './AssemblyTemplatesRowExpand';

export default {
  expandable: {
    label: '',
    isExpandable: true,
    render: (props: { item: AssemblyTemplateBEResponse; isCollapsed: boolean }) => <AssemblyTemplatesRowExpand {...props} />
  },
  id: {
    label: 'Template ID',
    sortField: 'id',
    minWidth: 75
  },
  name: {
    label: 'Template Name',
    minWidth: 250,
    render: (cell: AssemblyTemplate['name'], row: AssemblyTemplate) => (
      <EditableTextCell
        value={cell}
        row={row}
        update="assemblyTemplate"
        field="name"
        emptyText="-"
        validation={{
          regex: /^.{1,100}$/,
          message: 'Template name must be between 1 and 100 characters'
        }}
      />
    ),
    required: true
  },
  created_at: {
    label: 'Created At',
    render: (cell: AssemblyTemplate['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  created_by: {
    label: 'Created By',
    minWidth: 250,
    render: (cell: AssemblyTemplate['created_by']) => <UserDisplay user={cell} emptyText="-" />
  },
  template_type: {
    label: 'Template Type',
    minWidth: 200,
    render: (cell: AssemblyTemplate['template_type']) => capitalizeNoun(cell)
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_cell: any, row: AssemblyTemplate) => <AssemblyTemplatesOverflowMenu row={row} />
  }
};
